import { render, staticRenderFns } from "./creditStatus.vue?vue&type=template&id=629c6a1e&scoped=true&"
import script from "./creditStatus.vue?vue&type=script&lang=js&"
export * from "./creditStatus.vue?vue&type=script&lang=js&"
import style0 from "./creditStatus.vue?vue&type=style&index=0&id=629c6a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629c6a1e",
  null
  
)

export default component.exports